import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AlertDialogComponent} from 'src/app/shared/alert-dialog/alert-dialog.component';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private matDialog: MatDialog) {}

  public openAlertDialog(
    width: string = '350px',
    text: string,
    title: string = 'ALERT',
    confirmButtonLabel: string = 'close',
    panelClass: string
  ) {
    this.matDialog.open(AlertDialogComponent, {
      width,
      data: {
        text,
        title,
        confirmButtonLabel,
      },
      panelClass
    });
  }

  public openConfirmDialog(
    text: string,
    title: string = 'CONFIRMATION',
    confirmButtonLabel: string = 'Confirm',
    cancelButtonLabel: string = 'Cancel'
  ): Observable<any> {
    return this.matDialog
      .open(AlertDialogComponent, {
        height: '240px',
        width: '350px',
        data: {
          text,
          title,
          confirmButtonLabel,
          cancelButtonLabel,
          showCancelButton: true,
        },
      })
      .afterClosed();
  }
}
